import { FC, PropsWithChildren, useEffect, useState } from 'react'
import { checkTokenExpiration } from '@/utils/tokenExpirationCheck'
import { redirectToLogin } from '@/utils/authRedirect'

export const Authorization: FC<PropsWithChildren> = ({ children }) => {
  const [isChecking, setIsChecking] = useState(true)

  useEffect(() => {
    checkTokenExpiration()
      .then((isValid) => {
        if (!isValid) {
          redirectToLogin()
        } else {
          setIsChecking(false)
        }
      })
      .catch(() => {
        // Network error or unexpected failure — allow app to render
        // rather than showing a permanent blank screen
        setIsChecking(false)
      })
  }, [])

  useEffect(() => {
    const handlePageShow = (e: PageTransitionEvent) => {
      if (e.persisted) {
        checkTokenExpiration().then((isValid) => {
          if (!isValid) redirectToLogin()
        })
      }
    }
    window.addEventListener('pageshow', handlePageShow)
    return () => window.removeEventListener('pageshow', handlePageShow)
  }, [])

  if (isChecking) return null

  return <>{children}</>
}
